module.exports = __webpack_public_path__ + "img/05.5a3be447.png";